import { render, staticRenderFns } from "./VSubMenu.vue?vue&type=template&id=8373a8ce&scoped=true&"
import script from "./VSubMenu.vue?vue&type=script&lang=js&"
export * from "./VSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./VSubMenu.vue?vue&type=style&index=0&id=8373a8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8373a8ce",
  null
  
)

export default component.exports